import React from "react";

const SearchBar = ({ lang, search, handleSearch, options, setSearch }) => {
  return (
    <div className={lang === "AR" ? "search-bar_ar" : "search-bar"}>
      <div className="searcher">
        <input value={search.value} onChange={handleSearch} />
      </div>

      <div className="selector">
        <select
          onChange={(val) => {
            setSearch((prev) => ({ ...prev, type: val.target.value }));
          }}
        >
          {options.map((item, index) => {
            return (
              <option selected={index === 0 ? true : false} value={item.key}>
                {item.value}
              </option>
            );
          })}
        </select>
      </div>
    </div>
  );
};

export default SearchBar;
